import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ColumnSearch extends Component {
  constructor(props) {
    super(props);

    this.handleKeyPressed = this.handleKeyPressed.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onClearClick = this.onClearClick.bind(this);
    this.showClearButtonIfNeeded = this.showClearButtonIfNeeded.bind(this);

    this.state = {
      clearHidden: true,
    };
  }

  onSearchClick() {
    const $table = $(`#${this.props.tableId}_parent`);
    const value = $table.find('#search_field').val();
    if (!value) {
      return;
    }

    const searchQuery = [];
    searchQuery.push('ignored');
    searchQuery.push(':');
    searchQuery.push(value);

    this.props.onSearchClick(searchQuery.join(','));
  }

  onClearClick() {
    $(`#${this.props.tableId}_parent`).find('#search_field').val('');
    this.setState({clearHidden: true});
    this.props.onSearchClick('');
  }

  handleKeyPressed(e) {
    if (e.code === 'Enter' || e.code === 'NumpadEnter') {
      this.onSearchClick();
    }
  }

  showClearButtonIfNeeded() {
    const value = $(`#${this.props.tableId}_parent`).find('#search_field').val();
    this.setState({clearHidden: value === ''});
  }

  render() {
    return (
      <div>
        <div className='searchForm'>
          <input
            onKeyUp={this.showClearButtonIfNeeded}
            onKeyDown={this.handleKeyPressed}
            className="form-control searchForm-input"
            id="search_field"
            aria-controls={this.props.tableId}
            placeholder='Search by anything...'
          />
          <span
            hidden={this.state.clearHidden}
            className='clearForm-button'
            onClick={this.onClearClick}
          >
            X
          </span>
          <button
            className='searchForm-button'
            onClick={this.onSearchClick}
          >
            <i className='icon-magnifier'/>
          </button>
        </div>
      </div>
    );
  }
}

ColumnSearch.propTypes = {
  tableId: PropTypes.string,
  onSearchClick: PropTypes.func,
  options: PropTypes.array,
};
ColumnSearch.defaultProps = {};

export default ColumnSearch;
